import { useMemo } from 'react';
import JSON_DATA_HEADER from '../data/header.json';
export const useHeaderHistorico = ({ administrador }) => {
    return useMemo(() => {
        JSON_DATA_HEADER[JSON_DATA_HEADER.length - 1].width = '13rem';
        return JSON_DATA_HEADER;
    }, []);
};
